/* eslint-disable-next-line */
import { globalHistory } from '@reach/router';

import {
  recordSecondsOnPage,
  recordSecondsToLoad,
  recordLandedOnPage,
  recordUserBounce,
  recordVisitedPage
} from './src/utils/vanityMetrics';

import { resetDrift } from './src/utils/drift.ts';

let landed = false;
let leaving;

const shouldUpdateScroll = ({
  routerProps: {
    location: { pathname }
  }
}) => {
  if (pathname.indexOf('/resource-center') !== -1) {
    return false;
  }

  return true;
};

const onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
  const preloadChart = document.createElement('iframe');
  preloadChart.style.display = 'none';
  preloadChart.src = 'https://www.lucidchart.com/documents/preloadChart';

  window.addEventListener('load', () => {
    window.setTimeout(() => {
      recordSecondsToLoad();
      document.getElementsByTagName('body')[0].appendChild(preloadChart);
    });
  });

  window.addEventListener('beforeunload', () => {
    recordSecondsOnPage(window.location.pathname);
    if (landed === true && leaving === true) {
      recordUserBounce(window.location.pathname);
    }
  });
};

const onInitialClientRender = () => {
  leaving = true;
  if (document.referrer.indexOf('www.lucidchart.com') === -1) {
    landed = true;
    recordLandedOnPage(window.location.pathname);
  }

  if (window.location.search.indexOf('showEditLink=1') !== -1) {
    window.localStorage.setItem('showEditLink', '1');
  }

  /**
   * This is a workaround for a bug in Gatsby
   *
   * See https://github.com/gatsbyjs/gatsby/issues/8357 for more details
   */
  /* eslint-disable-next-line */
  globalHistory._onTransitionComplete();
};

const onRouteUpdate = () => {
  landed = false;
  leaving = false;

  let { pathname } = window.location;
  if (pathname === '/' || pathname === 'pages/') {
    pathname = 'homepage';
  }
  recordVisitedPage(pathname);
  resetDrift();

  Array.from(document.querySelectorAll('a')).forEach(link => {
    link.addEventListener('click', () => {
      if (link.href.indexOf('lucidchart.com') !== -1) {
        leaving = false;
      }
    });
  });

  Array.from(document.querySelectorAll('.js-eo-form')).forEach(form => {
    form.addEventListener('submit', () => {
      leaving = false;
    });
  });
};

export {
  onClientEntry,
  onRouteUpdate,
  onInitialClientRender,
  shouldUpdateScroll
};
